// https://mayursinhsarvaiya.medium.com/how-to-merge-refs-in-react-component-d5e4623b6924
export const mergeRefs = function <T>(...refs: React.MutableRefObject<T>[]) {
  return (node: T) => {
    for (const ref of refs) {
      if (ref) ref.current = node
    }
  }
}
